<script setup lang="ts">
/**
 * UI-kit component
 * Category: Selectors
 * Name: 'Checkboxes'
 * FIGMA: 'https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/Demo-CS?node-id=7680-2501'
 */
import { computed } from 'vue'

import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { faSquare } from '@fortawesome/pro-regular-svg-icons'
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { IconContainer } from '@shared/ui/icon'

defineOptions({
  name: 'BtnCheckbox',
})

const props = withDefaults(defineProps<BtnCheckboxProps>(), {
  checked: false,
  disabled: false,
  size: 'medium',
  mode: 'normal',
})

const emit = defineEmits<{
  click: []
}>()

interface BtnCheckboxProps {
  checked?: boolean
  disabled?: boolean
  size?: 'default' | 'medium' | 'extra-small' | 'small'
  mode?: InputMode
}

const handleClick = (): void => {
  if (!props.disabled) {
    emit('click')
  }
}

const icon = computed(() => props.checked ? faSquareCheck : faSquare)

</script>

<template>
  <button
    :class="['btn-checkbox', mode, { checked, disabled }]"
    :disabled="disabled"
    @click="handleClick"
  >
    <IconContainer :class="size">
      <FontAwesomeIcon
        :icon="icon"
      />
    </IconContainer>
  </button>
</template>

<style scoped lang="scss" src="./BtnCheckbox.scss" />
